var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-fssc22000-detail"},_vm._l((_vm.displayItems),function(item){return _c('div',{key:item.key,staticClass:"row mb-2"},[_c('div',{staticClass:"col-sm-6 font-weight-bold"},[_vm._v(_vm._s(item.label))]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_vm._v(_vm._s(item.value))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }